import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RegisterModel } from '../models/register.model';
import { AuthIntegrationType } from '../config/enums/auth-integration-type.enum';

@Injectable({
  providedIn: 'root'
})
export class RegisterRepository {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient
  ) { }

  public registerCostumer(registerForm: RegisterModel, recaptchaToken: string): Observable<RegisterModel> {
    let headers = new HttpHeaders();
    headers = headers.set('token-recaptcha', recaptchaToken);
    return this.httpClient.post<any>(`${this.apiUrl}/customer/create`, registerForm, { headers: headers });
  }

  public generateValidationCode(params: any, captcha: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('token-recaptcha', captcha);

    return this.httpClient.post<any>(`${this.apiUrl}/customer/create/generatecode-v1`, params, { headers: headers });
  }

  public checkValidationCode(params: any) {
    return this.httpClient.post<any>(`${this.apiUrl}/customer/create/validatecode`, params);
  }

  public checkAuthIntegration(cpf: string, type: AuthIntegrationType, referencialId?: string) {
    let url = `${this.apiUrl}/auth-integration/cpf/${cpf}?type=${type}`;
    if (referencialId) {
      url += `&referencialId=${referencialId}`;
    }
    return this.httpClient.get<any>(url);
  }

}
